import React from 'react';
import Button from '@99designs/frontend-components/components/Button/Button';
import Link from '../Link';
import { getComponentClasses } from '@99designs/frontend-components/utils/app/index';

interface CtaProps {
    label: string;
    url: string;
    color?: string;
    variations?: string[];
    shouldOpenInNewTab?: boolean;
}

interface Props {
    variations?: string[];
    primary: CtaProps;
    secondary: React.ReactNode;
}

export default function CtaPair(props: Props) {
    const className = getComponentClasses('cta-pair', props.variations);

    return (
        <div className={className}>
            <div className="cta-pair__button">
                <Button
                    href={props.primary.url}
                    variations={props.primary.variations ? props.primary.variations : []}
                    style={{ color: props.primary.color }}
                    target={props.primary.shouldOpenInNewTab ? '_blank' : ''}
                >
                    {props.primary.label}
                </Button>
            </div>
            <div className="cta-pair__link">{props.secondary}</div>
        </div>
    );
}
